import { setupTabs } from "@/components/tabs"
import { setupAccordions } from "@/components/content/Accordion"
import { setupNavbar } from "@/components/navbar"
import { setupSitewidePromo } from "@/components/sitewide_promotion"
import { setupGeolocation, listenToGeoPermissionChanges } from "@/components/geolocation"

import Cookies from "@/helpers/cookies"
import Emarsys from "@/helpers/emarsys"
import { setupGa4 } from "@/helpers/ga4_helper"

import { setupFooter } from "@/components/footer"

declare global {
  interface Window {
    clearExperimentCookie: () => void
    setExperimentCookie: (newCookie: string) => void
  }
}

const initExperiments = (): void => {
  const EXPERIMENT_COOKIE = "experiments"

  window.setExperimentCookie = (newCookie: string): void => {
    Cookies.set(EXPERIMENT_COOKIE, newCookie, { expires: 9999 })
  }

  window.clearExperimentCookie = (): void => {
    Cookies.remove(EXPERIMENT_COOKIE)
  }
}

const setTurboEval = (): void => {
  // Allow some GTM scripts to re-run by ignoring `data-turbo-eval="true"`
  const scriptSelector = "script:not([data-turbo-eval='true'])"

  document.body.querySelectorAll(scriptSelector).forEach((script) => {
    script.setAttribute("data-turbo-eval", "false")
  })
}

const scriptMutationObserver = (callback: () => void): void => {
  new window.MutationObserver((mutations): void => {
    mutations.forEach((mutation) => {
      if ([...mutation.addedNodes].some((node) => node.nodeName === "SCRIPT")) {
        callback()
      }
    })
  }).observe(document.body, { subtree: true, childList: true })
}

setupFooter()
setupTabs()
setupAccordions()
setupNavbar()
setupSitewidePromo()

const BROWSER_GEOLOCATION = document.body.getAttribute("data-browser-gelocation") === "true"

if (BROWSER_GEOLOCATION) {
  void (async (): Promise<void> => {
    await setupGeolocation()
    listenToGeoPermissionChanges()
  })()
}

// This gets called on every page to ensure the cart events get sent to emarsys.
Emarsys(window.emarsysData)

initExperiments()
setupGa4()
setTurboEval()
scriptMutationObserver(setTurboEval)
